export default {
  basicData: {
    lastName: 'Yagi',
    firstName: 'Taro',
    birthYear: '1995',
    birthMonth: '4',
    birthDay: '1',
    sex: '',
    tel1: '090',
    tel2: '1234',
    tel3: '5678',
    email: 'taro.yagi@example.com',
    idPhotoSrc: '',
    updateDate: ''
  },
  formatData: {
    createDate: new Date(),
    website: 'https://example.com/taro-yagi',
    recentPosition: 'Senior Software Engineer',
    address: '1-2-3 Shibuya, Shibuya-ku, Tokyo 150-0002, Japan',
    educationalHistories: [
      {
        year: '2014',
        month: '4',
        description:
          'XX University, Faculty of Engineering, Department of Computer Science (Enrolled)',
        uuid: 'a1e65b2f-9b9a-4c21-9f8c-9f1f3aa1b001'
      },
      {
        year: '2018',
        month: '3',
        description:
          'XX University, Faculty of Engineering, Department of Computer Science (Graduated)',
        uuid: 'a1e65b2f-9b9a-4c21-9f8c-9f1f3aa1b002'
      }
    ],
    skills: [
      'JavaScript / TypeScript',
      'Vue.js / React',
      'Node.js / Python',
      'English (Business level)'
    ],
    licenseHistories: [
      {
        year: '2017',
        month: '6',
        description: 'TOEIC Score 900',
        uuid: 'b1e65b2f-9b9a-4c21-9f8c-9f1f3aa1c001'
      }
    ],
    jobHistories: [
      {
        companyName: 'ABC Corporation',
        startYear: '2018',
        startMonth: '4',
        endYear: '',
        endMonth: '',
        isContinuing: true,
        businessArea: '',
        projects: [
          {
            projectTitle: 'Senior Software Engineer',
            startYear: '2020',
            startMonth: '4',
            endYear: '',
            endMonth: '',
            contentsOfProject:
              'Led the development of a web service. Designed architecture, managed a team of 5 engineers, and delivered features ahead of schedule.',
            envAndScale: '',
            position: '',
            uuid: 'c1e65b2f-9b9a-4c21-9f8c-9f1f3aa1d001'
          },
          {
            projectTitle: 'Software Engineer',
            startYear: '2018',
            startMonth: '4',
            endYear: '2020',
            endMonth: '3',
            contentsOfProject:
              'Implemented frontend features using Vue.js and REST APIs using Node.js.',
            envAndScale: '',
            position: '',
            uuid: 'c1e65b2f-9b9a-4c21-9f8c-9f1f3aa1d002'
          }
        ],
        uuid: 'd1e65b2f-9b9a-4c21-9f8c-9f1f3aa1e001'
      }
    ],
    prMessage:
      'Experienced software engineer with a passion for building scalable web applications. Strong background in full-stack development with expertise in JavaScript ecosystems. Proven track record of leading cross-functional teams and delivering high-quality products.'
  }
}
